import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {
  @Input() totalItems: number = 0;
  @Input() currentPage: number = 1;
  @Input() itemsPerPage: number = 10;
  @Input() pageSizeOptions: number[] = [10, 25, 50];

  @Output() pageEvent = new EventEmitter<{page: number, pageSize: number}>();

  handlePageEvent(event: any) {
    // Handle page change
    this.pageEvent.emit({page: event.pageIndex + 1, pageSize: event.pageSize});
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }
} 